/**
 * 340 (#932): the customer is now told about a staff change of car, time or pickup place, so every action
 * that makes one says so before staff confirm (booking detail cards, the schedule's move and resize).
 */
export const CUSTOMER_TOLD_TEXT = 'The customer will be told by email and in the app.';

export function CustomerToldNote() {
  return (
    <p className="mt-2 text-xs text-steel" data-testid="customer-told-note">
      {CUSTOMER_TOLD_TEXT}
    </p>
  );
}
